var map = {
	"./startup-box-icon-01.png": 1209,
	"./startup-box-icon-02.png": 8742,
	"./startup-box-icon-03.png": 1962,
	"./startup-box-icon-04.png": 1529,
	"./startup-box-icon-05.png": 9245,
	"./startup-box-icon-06.png": 5431
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3286;